/** Kartochka muharriri (demo `openSetEditor`/`drawSetEditor`): nom, bazadan 30 tagacha soʻz tanlash, oʻchirish. Stek ekrani. */
import { useState } from 'react';
import { W, BYID, TOPICS } from '../data';
import { useStore, S, today, lessonSource } from '../store';
import { nav } from '../lib/nav';
import { toast } from '../lib/toast';
import { startLesson } from './lesson/engine';
import { fire, sync } from '../lib/sync';
import { t, tn } from '../i18n';
import { Ic } from '../ui/Icon';
import { useSetsUi } from './Sets';

const MAX = 30;

export function SetEditor({ id }: { id: number | null }) {
  const wst = useStore((s) => s.w);
  const existing = (S().sets ?? []).find((x) => x.id === id);
  const [name, setName] = useState(existing ? existing.name : `${(S().sets ?? []).length + 1}-dars`);
  const [ids, setIds] = useState<number[]>(existing ? existing.ids.slice() : []);
  const [q, setQ] = useState('');
  const [topic, setTopic] = useState('all');
  const [confirm, setConfirm] = useState(false);

  const topics = ['all', ...TOPICS];
  const qq = q.toLowerCase();
  const list = W.filter((w) => (topic === 'all' || w.topic === topic) && (!qq || w.w.toLowerCase().includes(qq) || w.uz.toLowerCase().includes(qq)));
  const full = ids.length >= MAX;
  const shown = list.slice(0, 200); // minglab tugma DOM'ni sekinlashtiradi; qidiruv bilan toraytiriladi

  const backToMine = () => { useSetsUi.getState().set({ segT: 'mine' }); nav.home('sets'); };

  const del = () => {
    const s = S(); const sets = (s.sets ?? []).filter((x) => x.id !== id);
    const activeSet = s.activeSet === id ? (sets.length ? sets[sets.length - 1]!.id : null) : s.activeSet;
    s.set({ sets, activeSet });
    if (id !== null) fire(sync.deleteSet(id).then(() => (activeSet !== null ? sync.course({ active_set_id: activeSet }) : sync.course({ clear_active_set: true }))), 'set-delete');
    backToMine(); toast(t('Kartochka oʻchirildi'));
  };

  const save = () => {
    const s = S(); const all = s.sets ?? [];
    const nm = (name || '').trim() || `${all.length + 1}-dars`;
    let sid = id; let sets: typeof all;
    if (sid !== null && all.some((x) => x.id === sid)) {
      sets = all.map((x) => (x.id === sid ? { ...x, name: nm, ids: ids.slice() } : x));
      const id0 = sid;
      fire(sync.updateSet(id0, { name: nm, ids: ids.slice() }).then(() => sync.course({ active_set_id: id0 })), 'set-update');
    } else {
      sid = Date.now(); sets = [...all, { id: sid, name: nm, ids: ids.slice(), created: today() }];
      const tmp = sid;
      // Server id'si bilan almashtiriladi (lokal id — vaqtinchalik)
      fire(sync.createSet(nm, ids.slice()).then((r) => {
        const st = S();
        st.set({ sets: (st.sets ?? []).map((x) => (x.id === tmp ? { ...x, id: r.id } : x)), activeSet: st.activeSet === tmp ? r.id : st.activeSet });
        return sync.course({ active_set_id: r.id });
      }), 'set-create');
    }
    s.set({ sets, activeSet: sid, mode: 'center' });
    fire(sync.me({ mode: 'center' }), 'mode');
    if (lessonSource().length) { backToMine(); startLesson(); }
    else { toast(t('Bu soʻzlar allaqachon oʻrganilgan')); backToMine(); }
  };

  const toggle = (wid: number, on: boolean) => {
    if (on) { if (ids.length < MAX && !ids.includes(wid)) setIds([...ids, wid]); }
    else setIds(ids.filter((x) => x !== wid));
  };

  return (
    <>
      <div className="sbar">
        <button className="x" aria-label={t('Orqaga')} onClick={backToMine}><Ic n="back" /></button>
        <b style={{ flex: 1, textAlign: 'left', color: 'var(--ink)', fontSize: 16 }}>{id ? t('Kartochkani tahrirlash') : t('Yangi kartochka')}</b>
      </div>
      <div className="sbody fade" style={{ gap: 14 }}>
        <div className="col g8">
          <label className="cap" htmlFor="sn">{t('Kartochka nomi')}</label>
          <div className="field"><input id="sn" value={name} maxLength={30} placeholder={t('Masalan: 3-dars')} onChange={(e) => setName(e.target.value)} /></div>
        </div>
        <div className="between">
          <span className="t15b"><span>{ids.length}</span> {tn('/ # soʻz', MAX)}</span>
          <span className="t12">{full ? t('Kartochka toʻldi') : t('Bazadan soʻz tanlang')}</span>
        </div>
        {ids.length > 0 && (
          <div className="chips">
            {ids.map((wid) => <button key={wid} className="f on" onClick={() => setIds(ids.filter((x) => x !== wid))}>{BYID[wid]?.w} ✕</button>)}
          </div>
        )}
        <label className="search"><Ic n="search" size={20} /><input type="search" placeholder={t('Bazadan soʻz qidirish')} value={q} onChange={(e) => setQ(e.target.value)} /></label>
        <div className="chips scroll">
          {topics.map((tp) => <button key={tp} className="f" aria-pressed={topic === tp} onClick={() => setTopic(tp)}>{tp === 'all' ? t('Hammasi') : t(tp)}</button>)}
        </div>
        <div className="wl">
          {list.length ? shown.map((w) => {
            const on = ids.includes(w.id);
            return (
              <label key={w.id} className="wr pick">
                <input type="checkbox" checked={on} disabled={!on && full} onChange={(e) => toggle(w.id, e.target.checked)} />
                <span className="box"><Ic n="check" /></span>
                <div className="grow"><b>{w.w}</b><span>{w.uz}</span></div>
                {wst[w.id] ? <span className="t12" style={{ color: 'var(--success-ink)', fontWeight: 700 }}>{t('oʻrganilgan')}</span> : <span className="t12">{t(w.topic)}</span>}
              </label>
            );
          }) : <p className="t13">{t('Hech narsa topilmadi.')}</p>}
        </div>
        {id ? (confirm
          ? <div className="row g10"><button className="btn soft" style={{ height: 44 }} onClick={() => setConfirm(false)}>{t('Bekor qilish')}</button><button className="btn" style={{ height: 44, background: 'var(--error-strong)', color: '#fff' }} onClick={del}>{t('Oʻchirish')}</button></div>
          : <button className="row g8 t13" style={{ color: 'var(--error-ink)', fontWeight: 800, alignSelf: 'flex-start' }} onClick={() => setConfirm(true)}><Ic n="trash" size={18} />{t('Kartochkani oʻchirish')}</button>) : null}
      </div>
      <div className="sfoot"><button className="btn" disabled={!ids.length} onClick={save}>{ids.length ? t('Saqlash va oʻrganish') : tn('Kamida # ta soʻz tanlang', 1)}</button></div>
    </>
  );
}
